package com.essntl.features.request.ui.addeditrequest

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class AddEditRequestState(
    val request: MutableState<RequestModel> = mutableStateOf(
        RequestModel.empty.copy(
            status = RequestModel.Status.Todo,
        ),
    ),
    val getRequest: State<RequestModel> = State(),
    val addEditRequest: State<RequestModel> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getAllTravelAgent: PaginationState<TravelAgentModel> = PaginationState(),
    val getAllClient: State<List<ClientModel>> = State(),
    val loadingRemoveClient: List<String> = emptyList(),
    val getAllTravelAgents: State<List<TravelAgentModel>> = State(),
    val addEditTravelAgent: State<TravelAgentModel> = State(),
    val loadingRemoveTravelAgent: List<String> = emptyList(),
    val isEditEnabled: Boolean = false,
)
